import { useT } from "../i18n";

/**
 * LegalLinks points at the privacy policy and the terms (requirement 0061),
 * and on the landing page at /about, which Google for Startups reviewers must
 * find linked from the public site.
 *
 * Plain anchors, never router links: the pages are whole HTML documents the
 * server serves (ADR-0130), and the SPA's catch-all route would otherwise
 * swallow the path and send the reader home.
 */
export default function LegalLinks({
  className = "",
  about = false,
}: {
  className?: string;
  about?: boolean;
}) {
  const t = useT();
  const link = "underline-offset-4 hover:text-ink hover:underline";
  return (
    <p className={`flex items-center justify-center gap-2 text-xs text-muted ${className}`}>
      <a href="/privacy" data-testid="privacy-link" className={link}>
        {t.legal.privacy}
      </a>
      <span aria-hidden>·</span>
      <a href="/terms" data-testid="terms-link" className={link}>
        {t.legal.terms}
      </a>
      {about && (
        <>
          <span aria-hidden>·</span>
          <a href="/about" data-testid="about-link" className={link}>
            {t.legal.about}
          </a>
        </>
      )}
    </p>
  );
}
